import { Component, OnInit, Input, ViewChild, ElementRef } from "@angular/core";
import { CommonService } from "src/app/common.service";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from "@angular/forms";
import * as moment from "moment";
import { MustBeAfter } from "../utils/must-be-after.validator";
import { InlineResponse200 } from "profile-api";
import {
  Tender,
  Base64Document,
  Participation,
  RequestDetail,
  TenderInvitationService,
  ClusterSector,
  TenderInvitation,
  MinimumRequirement,
} from "tender-api";
import { ModalComponent } from "../modal/modal.component";
import {
  GetTenderStatusDescription,
  GetTenderAttachmentTypeDersciption,
} from "../utils/tender-utils";
import { Router } from "@angular/router";
import { SharingRequest } from "sharing-api";
import { InvalidControlScrollDirective } from "../ng-invalid-control-scroll-wt-directive.directive";
import { DesignerCard, DesignerList } from "designer-api";
import { ConfigurationVariablesList } from "std-api";

class SelectableParticipation {
  participation: Participation;
  selectedClass: string;
}

class MinimumRequirementItem {
  minimumRequirement: MinimumRequirement;
  errorMessage: string;
}

class ClusterSectorItem {
  clusterSector: ClusterSector;
  errorMessage: string;
}

@Component({
  selector: "app-tender-detail",
  templateUrl: "./tender-detail.component.html",
  styleUrls: ["./tender-detail.component.css"],
})
export class TenderDetailComponent implements OnInit {
  @Input("tenderId") tenderId: number;

  @ViewChild("metricCalculationModal") metricCalculationModal: ModalComponent;
  @ViewChild("uploadMetricCalculationDocInput")
  uploadMetricCalculationDocInput: ElementRef;
  @ViewChild("confirmationModal") confirmationModal: ModalComponent;
  @ViewChild("sharingEmailRequestModal")
  sharingEmailRequestModal: ModalComponent;
  @ViewChild("sharingEmailOkModal") sharingEmailOkModal: ModalComponent;
  @ViewChild("searchDesignerModal") searchDesignerModal: ModalComponent;
  @ViewChild("searchDesignerOkModal") searchDesignerOkModal: ModalComponent;
  @ViewChild("searchDesignerKoModal") searchDesignerKoModal: ModalComponent;
  @ViewChild("toManyAttachmentsWarningModal")
  toManyAttachmentsWarningModal: ModalComponent;
  @ViewChild("uploadImageInput") uploadImageInput: ElementRef;
  @ViewChild("uploadDrawingInput") uploadDrawingInput: ElementRef;
  @ViewChild("uploadOtherInput") uploadOtherInput: ElementRef;
  @ViewChild("applicationsModal") applicationsModal: ModalComponent;
  @ViewChild("confirmationModalDeal") confirmationModalDeal: ModalComponent;

  locale: string = "it";

  tenderForm: FormGroup;
  sharingForm = new FormGroup({
    sharingEmail: new FormControl("", [
      Validators.required,
      Validators.email,
      Validators.pattern(CommonService.EMAIL_REGEXP),
    ]),
  });
  loadedTender: Tender;
  needForSubmit: boolean = false;
  provinces = null;
  hours = null;
  loading = false;
  sharingLoading = false;
  designerLoading = false;
  selectedCluster:number = 10;
  error = "no_error";
  sharingError = "no_error";
  designerError = "no_error";
  detailListError = "no_error";
  clusterErrorMessage = "no_error";
  tenderCategory: Tender.CategoryCodeEnum = null;
  paymentMethod: Tender.PaymentMethodEnum = null;
  constructionBox: string = "";
  renovationBox: string = "";
  systemBox: string = "";
  excavationBox: string = "";
  demolitionBox: string = "";
  categoryError: string = "no_error";
  startDateAlert: string = "";
  endDateAlert: string = "";
  maximumEstimateDateAlert: string = "";
  saveMessage: string = "La gara è stata pubblicata correttamente.";
  showSaveMessage: boolean = false;
  qualifications: Boolean;
  errorQualifications: boolean = false;
  visibility: Boolean;
  errorVisibility: boolean = false;
  subcontract: Boolean;
  errorSubcontract: boolean = false;
  showBestOffer: Boolean;
  errorShowBestOffer: boolean = false;
  attachments: Array<Base64Document> = [];
  metricCalculationTemplate: Base64Document;
  metricCalculationDoc: Base64Document;
  errorMetricCalculationDoc: boolean = false;
  metricComputationMsg: string =
    "Per poter pubblicare la gara è necessario caricare il computo metrico.";
  metricComputationMsgClass: string = "alert";
  canChangeTender: boolean = true;
  canAskDiscount: boolean = false;
  tenderStatus: string;
  tenderStatusDescr: string;
  publishedParticipations: Array<SelectableParticipation>;
  draftParticipationCountMessage: string;
  confirmationModalMsg: string;
  confirmationModalSubmitMsg: string;
  isGoingToAcceptTender: boolean = false;
  metricCalculationInstruction: Base64Document;
  designerFilter: string;
  designers: Array<DesignerCard>;
  selectedDesigner: DesignerCard;
  showDesignerSelect: boolean = false;
  requestDataEntryType: string;
  errorRequestDataEntryType: boolean;
  requestDetails: Array<RequestDetail>;
  unitOfMeasureList = null;
  privateTenderMaxAttachmentNumber: number = null;
  feedbackExists: boolean = null;
  tenderInvitations: TenderInvitation[] = null;
  bestOffers: Participation[] = [];
  minimumRequirements: MinimumRequirementItem[] = [];
  maxApplications: number;
  showMaxApplications: boolean;
  draftParticipations: Participation[] = [];
  participationIdSelected: number = null;
  applicationsModalMsg: string = null;
  applicationsModalSubmitMsg: string = null;
  applicationsModalAcceptance: boolean = null;
  clusterSectorMessage: string = "no_error";
  clusterSectors: ClusterSectorItem[] = [];
  sectorCompanyList = null;

  constructor(
    private commonService: CommonService,
    private router: Router,
    private formBuilder: FormBuilder,
    private el: ElementRef,
    private invalidControlScrollDirective: InvalidControlScrollDirective
  ) {}

  ngOnInit(): void {
    console.log("Tender id = " + this.tenderId);

    this.checkFeedbackToken(this.tenderId);

    window["moment"] = moment;

    this.tenderForm = this.formBuilder.group(
      {
        serialNumber: new FormControl(""),
        title: new FormControl("", [Validators.required]),
        contactName: new FormControl(null),
        contactPhone: new FormControl(null),
        contactEmail: new FormControl("", [
          Validators.pattern(CommonService.EMAIL_REGEXP),
        ]),
        description: new FormControl("", [Validators.required]),
        provinceCode: new FormControl("", [Validators.required]),
        maximumEstimateHour: new FormControl(null),
        city: new FormControl(null),
        zipCode: new FormControl(null),
        address: new FormControl(null),
        addressNumber: new FormControl(null),
        maximumEstimateDate: new FormControl("", [Validators.required]),
        startDate: new FormControl("", [Validators.required]),
        endDate: new FormControl("", [Validators.required]),
        visibilityTrue: new FormControl(null),
        visibilityFalse: new FormControl(null),
        qualificationsTrue: new FormControl(null),
        qualificationsFalse: new FormControl(null),
        subcontractTrue: new FormControl(null),
        subcontractFalse: new FormControl(null),
        showBestOfferTrue: new FormControl(null),
        showBestOfferFalse: new FormControl(null),
        showMetricCalculation: new FormControl(null),
        requestDataEntryTypeMetricCalculation: new FormControl(null),
        requestDataEntryTypeDetailList: new FormControl(null),
        maxApplicationsCheck: new FormControl(null),
        inputMaxApplications: new FormControl(null),
      },
      {
        validator: MustBeAfter("startDate", "endDate"),
      }
    );
    this.checkFeedbackToken(this.tenderId);

    this.hours = Array.from(Array(23).keys());
    // console.log(
    //   "HOURSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS: " +
    //     JSON.stringify(this.hours)
    // );

    this.commonService
      .getProvinces()
      .then((provinceList: InlineResponse200) => {
        this.provinces = provinceList;
      })
      .catch((error) => {
        this.error = "Impossibile caricare la lista delle province.";
        console.log(error);
      });

    
      
    let startDateControl = this.tenderForm.get("startDate");
    startDateControl.valueChanges.subscribe((date) => {
      if (startDateControl.invalid) {
        this.startDateAlert = "ng-date-container-alert";
      } else {
        this.startDateAlert = "";
        this.resetError();
      }
    });

    let maximumEstimateDateControl = this.tenderForm.get("maximumEstimateDate");
    maximumEstimateDateControl.valueChanges.subscribe((date) => {
      if (maximumEstimateDateControl.invalid) {
        this.maximumEstimateDateAlert = "ng-date-container-alert";
      } else {
        this.maximumEstimateDateAlert = "";
        this.resetError();
      }
    });

    this.checkFeedbackToken(this.tenderId);
    let endDateControl = this.tenderForm.get("endDate");
    endDateControl.valueChanges.subscribe((date) => {
      setTimeout(() => {
        if (endDateControl.invalid) {
          this.endDateAlert = "ng-date-container-alert";
        } else {
          this.endDateAlert = "";
          this.resetError();
        }
      });
    });

    this.commonService
      .getTenderService()
      .tenderTenderIdGet(this.tenderId)
      .subscribe(
        (tender) => {
          console.log("loaded tender");
          console.log(tender);
          this.loadedTender = tender;
          this.loadTenderInForm(tender);
          this.loadParticipations(tender);
          this.loadMinimumRequirements(tender);
          this.loadClusterSectors(tender);
        },
        (error) => {
          console.log(
            "Impossibile caricare la gara " +
              this.tenderId +
              "; error: " +
              error
          );
        },
        () => {
          this.getBestOffers();
        }
      );

    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("UNIT_OF_MEASURE")
      .subscribe(
        (data) => {
          this.unitOfMeasureList = data.items;
          // console.log(
          //   "Unit of measure: " + JSON.stringify(this.unitOfMeasureList)
          // );
        },
        (error) => {
          this.error = "Impossibile caricare la lista delle unità di misura.";
          console.log(error);
        }
      );

    this.commonService
      .getConfigurationVariables()
      .then((variables: ConfigurationVariablesList) => {
        // console.log(
        //   "PRIVATE_TENDER_MAX_ATTACHMENT_NUMBER: " +
        //     variables["PRIVATE_TENDER_MAX_ATTACHMENT_NUMBER"]
        // );
        this.privateTenderMaxAttachmentNumber =
          variables["PRIVATE_TENDER_MAX_ATTACHMENT_NUMBER"];
      });

    this.commonService
      .getTenderInvitationService()
      .tenderTenderIdInvitationGet(this.tenderId)
      .subscribe((invitations) => {
        // console.log("Inviti vari");
        // console.log(invitations);
        if (invitations.length > 0) {
          this.tenderInvitations = invitations;
        }
      });

     this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("SECTOR_COMPANY")
      .subscribe(
        (data) => {
          this.sectorCompanyList = data.items;
        },
        (error) => {
          this.error = "Impossibile caricare la lista dei settori di impresa.";
          console.log(error);
        }
     );
    
    this.getBestOffers();
  }

  setCategory(category: Tender.CategoryCodeEnum) {
    this.tenderCategory = category;
    switch (category) {
      case Tender.CategoryCodeEnum.Construction:
        this.loadConstruction();
        break;
      case Tender.CategoryCodeEnum.Demolition:
        this.loadDemolition();
        break;
      case Tender.CategoryCodeEnum.Excavation:
        this.loadExcavation();
        break;
      case Tender.CategoryCodeEnum.Renovation:
        this.loadRenovation();
        break;
      case Tender.CategoryCodeEnum.System:
        this.loadSystem();
        break;
      default:
        break;
    }
  }

  getBestOffers() {
    // console.log("processing best offers");
    for (let participation of this.loadedTender.participations) {
      if (participation.bestOffer == this.loadedTender.bestOffer) {
        this.bestOffers.push(participation);
      }
    }
    // console.log("best offers");
    // console.log(this.bestOffers);
  }

  loadParticipations(tender: Tender) {
    const draftParticipationCount = tender.participations.reduce(
      (acc, item) => acc + (item.participationStatus === "DRAFT" ? 1 : 0),
      0
    );
    if (draftParticipationCount === 1) {
      this.draftParticipationCountMessage = "c'è un offerente che non ha";
    } else if (draftParticipationCount > 1) {
      this.draftParticipationCountMessage =
        "ci sono " + draftParticipationCount + " offerenti che non hanno";
    }
    let filteredParticipations = tender.participations.filter(
      (item) => item.participationStatus !== "DRAFT"
    );
    this.publishedParticipations = filteredParticipations.map((item) => ({
      participation: item,
      selectedClass: "",
    }));

    this.draftParticipations = tender.participations.filter(
      (item) =>
        item.participationStatus === "DRAFT" &&
        item.invitationToken == null &&
        item.accepted == null
    );

  }

  loadTenderInForm(tender: Tender) {
    this.tenderForm.reset(tender);

    //Set category in form
    this.setCategory(tender.categoryCode);
    //Set expected dates in form
    this.tenderForm.patchValue({
      startDate: moment(tender.expectedStartDate).toDate(),
    });
    this.tenderForm.patchValue({
      endDate: moment(tender.expectedEndDate).toDate(),
    });
    this.tenderForm.patchValue({
      maximumEstimateDate: moment(tender.maximumEstimateDate).toDate(),
    });
    this.paymentMethod = tender.paymentMethod;
    //Set qualifications
    this.qualifications = tender.qualifications;
    if (tender.qualifications !== null && tender.qualifications !== undefined) {
      this.setQualification(tender.qualifications);
    }

    //Set visibility
    if (tender.privateTender !== null && tender.privateTender !== undefined) {
      this.setVisibility(!tender.privateTender);
    }

    // max applications

    if (
      tender.maxApplications === null ||
      tender.maxApplications === undefined
    ) {
      this.showMaxApplications = false;
      this.setMaxApplicationsValidators();
      this.tenderForm.patchValue({
        maxApplicationsCheck: this.showMaxApplications,
      });
    } else {
      this.showMaxApplications = true;
      this.setMaxApplicationsValidators();
      this.tenderForm.patchValue({
        maxApplicationsCheck: this.showMaxApplications,
      });
    }

    this.maxApplications = tender.maxApplications;

    this.tenderForm.patchValue({
      inputMaxApplications: this.maxApplications,
    });

    this.setDefaultMaxApplications();

    //Set subcontract
    this.subcontract = tender.subcontract;
    if (tender.subcontract !== null && tender.subcontract !== undefined) {
      this.setSubcontract(tender.subcontract);
    }
    //Set showBestOffer
    this.showBestOffer = tender.showBestOffer;
    if (tender.showBestOffer != null && tender.showBestOffer != undefined) {
      this.setShowBestOffer(tender.showBestOffer);
    }
    if (tender.serialNumber != null && tender.serialNumber != undefined) {
      this.tenderForm.controls["serialNumber"].setValue(tender.serialNumber);
    } else {
      this.tenderForm.controls["serialNumber"].setValue("Nessuna Informazione");
    }

    //disable show best Offer for private tender
    if (this.loadedTender.tenderType === "PRIVATE") {
      this.tenderForm.get("showBestOfferTrue").disable();
      this.tenderForm.get("showBestOfferFalse").disable();

      // const controls = this.tenderForm.controls;
      // Object.keys(controls).forEach((controlName) =>
      //   controls[controlName].disable()
      // );
    }

    //Set attachments
    this.attachments = tender.attachments;

    //Set requestDataEntryType
    this.requestDataEntryType = tender.requestDataEntryType;
    if (tender.requestDataEntryType) {
      this.setRequestDataEntryType(tender.requestDataEntryType);
    }

    //Set metricCalculation
    this.metricCalculationTemplate = tender.metricCalculationTemplate;
    this.metricCalculationDoc = tender.metricCalculationDoc;
    this.metricCalculationInstruction = tender.metricCalculationInstruction;

    this.canChangeTender =
      tender.tenderStatus === "DRAFT" && tender.customer === null;
    this.canAskDiscount =
      (tender.tenderStatus === "ONGOING" ||
        tender.tenderStatus === "DISCOUNT") &&
      tender.customer === null;

    this.tenderStatus = tender.tenderStatus;
    this.tenderStatusDescr = GetTenderStatusDescription(tender.tenderStatus);

    //disable form controll if the tender has already been published (status !== DRAFT or if logged user is not the owner (shared tender))
    if (!this.canChangeTender) {
      const controls = this.tenderForm.controls;
      Object.keys(controls).forEach((controlName) => {
        controls[controlName].disable();
      });
    }

    this.requestDetails = tender.requestDetails;
  }

  resetCategoryBox() {
    this.constructionBox = "";
    this.renovationBox = "";
    this.systemBox = "";
    this.excavationBox = "";
    this.demolitionBox = "";
    this.categoryError = "no_error";
    this.resetError();
  }

  loadConstruction() {
    this.tenderCategory = Tender.CategoryCodeEnum.Construction;
    this.resetCategoryBox();
    this.constructionBox = "ng-selected-category-box";
  }

  selectConstruction() {
    if (this.canChangeTender) {
      this.loadConstruction();
    }
  }

  loadRenovation() {
    this.tenderCategory = Tender.CategoryCodeEnum.Renovation;
    this.resetCategoryBox();
    this.renovationBox = "ng-selected-category-box";
  }

  selectRenovation() {
    if (this.canChangeTender) {
      this.loadRenovation();
    }
  }

  loadSystem() {
    this.tenderCategory = Tender.CategoryCodeEnum.System;
    this.resetCategoryBox();
    this.systemBox = "ng-selected-category-box";
  }

  selectSystem() {
    if (this.canChangeTender) {
      this.loadSystem();
    }
  }

  loadExcavation() {
    this.tenderCategory = Tender.CategoryCodeEnum.Excavation;
    this.resetCategoryBox();
    this.excavationBox = "ng-selected-category-box";
  }

  selectExcavation() {
    if (this.canChangeTender) {
      this.loadExcavation();
    }
  }

  loadDemolition() {
    this.tenderCategory = Tender.CategoryCodeEnum.Demolition;
    this.resetCategoryBox();
    this.demolitionBox = "ng-selected-category-box";
  }

  selectDemolition() {
    if (this.canChangeTender) {
      this.loadDemolition();
    }
  }

  resetError() {
    this.error = "no_error";
  }

  getTender() {
    let formValues = this.tenderForm.getRawValue();
    delete formValues.startDate;
    delete formValues.endDate;

    delete formValues.maxApplicationsCheck;
    delete formValues.inputMaxApplications;

    let tender: Tender = formValues;

    tender.tenderId = this.tenderId;
    tender.categoryCode = this.tenderCategory;

    let expectedStartDate = moment(this.tenderForm.get("startDate").value);
    tender.expectedStartDate = expectedStartDate.format("YYYY-MM-DD");
    let expectedEndDate = moment(this.tenderForm.get("endDate").value);
    tender.expectedEndDate = expectedEndDate.format("YYYY-MM-DD");
    let maximumEstimateDate = moment(
      this.tenderForm.get("maximumEstimateDate").value
    );
    tender.maximumEstimateDate = maximumEstimateDate.format("YYYY-MM-DD");

    tender.paymentMethod = this.paymentMethod;

    if (this.visibility !== null && this.visibility !== undefined) {
      tender.privateTender = !this.visibility.valueOf();
    }
    delete formValues.visibilityFalse;
    delete formValues.visibilityTrue;

    if (this.qualifications !== null && this.qualifications !== undefined) {
      tender.qualifications = this.qualifications.valueOf();
    }
    delete formValues.qualificationsFalse;
    delete formValues.qualificationsTrue;

    if (this.subcontract !== null && this.subcontract !== undefined) {
      tender.subcontract = this.subcontract.valueOf();
    }
    delete formValues.subcontractFalse;
    delete formValues.subcontractTrue;

    if (this.showBestOffer !== null && this.showBestOffer !== undefined) {
      tender.showBestOffer = this.showBestOffer.valueOf();
    }

    delete formValues.showBestOfferTrue;
    delete formValues.showBestOfferFalse;

    delete formValues.requestDataEntryTypeMetricCalculation;
    delete formValues.requestDataEntryTypeDetailList;

    tender.attachments = this.attachments;

    tender.metricCalculationDoc = this.metricCalculationDoc;
    tender.metricCalculationTemplate = this.metricCalculationTemplate;
    tender.metricCalculationInstruction = this.metricCalculationInstruction;

    if (
      this.tenderForm.get("showMetricCalculation").value === null ||
      this.tenderForm.get("showMetricCalculation").value === undefined
    ) {
      tender.showMetricCalculation = false;
    }

    tender.requestDataEntryType = this.requestDataEntryType;
    if (this.requestDataEntryType !== "METRIC_CALCULATION") {
      tender.showMetricCalculation = true;
    }

    tender.tenderStatus = this.tenderStatus;

    tender.requestDetails = this.requestDetails;

    tender.maxApplications = this.maxApplications;

    // console.log(JSON.stringify(tender));

    return tender;
  }

  validateSaveData() {
    this.resetValidators();

    if (this.tenderCategory === null || this.tenderCategory === undefined) {
      this.categoryError = "Selezionare una categoria.";
      let invalidElement: HTMLElement = document.getElementById("category");
      this.invalidControlScrollDirective.manualScrollToFirstInvalidElementRef(
        invalidElement
      );
      return false;
    } else {
      this.categoryError = "no_error";
    }

     if (this.tenderForm.get("startDate").invalid) {
      this.startDateAlert = "ng-date-container-alert";
    } else {
      this.startDateAlert = "";
    }

    if (this.tenderForm.get("endDate").invalid) {
      this.endDateAlert = "ng-date-container-alert";
    } else {
      this.endDateAlert = "";
    }

    const someAttributeNull = (element: RequestDetail) =>
      !element.amount || !element.description || !element.unitOfMeasureCode;

    if (this.requestDetails.some(someAttributeNull)) {
      this.detailListError = "Compilare tutti i campi dei dettagli.";
      return false;
    }

    if (!this.tenderForm.valid) {
      const controls = this.tenderForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          let invalidElement: HTMLElement = document.getElementById(name);
          this.invalidControlScrollDirective.manualScrollToFirstInvalidElementRef(
            invalidElement
          );
          break;
        }
      }
      return false;
    }

    return true;
  }

  saveTender() {
    this.loading = true;
    if (!this.validateSaveData()) {
      this.error = "I campi non sono compilati correttamente.";
      console.log("Invalid tender save data.");
      this.loading = false;
      return;
    } else {
      this.error = "no_error";
    }

    let tender: Tender = this.getTender();
   
    tender.cluster = this.loadedTender.cluster;

    tender.minimumRequirements = this.minimumRequirements.map(
      (item) => item.minimumRequirement
    );
    tender.clusterSectors = this.clusterSectors.map(
      (item) => item.clusterSector
    );

    console.log(tender);

    this.commonService
      .getTenderService()
      .tenderTenderIdPut(tender.tenderId, tender)
      .subscribe(
        (tender: Tender) => {
          this.loadedTender = tender;
          this.loadTenderInForm(tender);
          this.loading = false;

          this.saveMessage = "La gara è stata salvata correttamente.";
          this.showSaveMessage = true;
          this.errorMetricCalculationDoc = false;
          this.errorQualifications = false;
          this.errorSubcontract = false;
          this.errorShowBestOffer = false;
          this.errorRequestDataEntryType = false;
          this.detailListError = "no_error";

          var that = this;
          setTimeout(function () {
            that.showSaveMessage = false;
          }, 4000);
        },
        (error) => {
          if (error.status === 400) {
            this.error = error.error.errors[0].text;
          } else {
            this.error =
              "Si è verificato un errore durante il salvataggio della gara.";
          }
          this.loading = false;
          console.log(error);
        }
      );
  }

  resetValidators() {
    if (this.needForSubmit) {
      this.tenderForm.get("contactName").setValidators([Validators.required]);
      this.tenderForm.get("contactName").updateValueAndValidity();
      this.tenderForm.get("contactPhone").setValidators([Validators.required]);
      this.tenderForm.get("contactPhone").updateValueAndValidity();
      this.tenderForm
        .get("contactEmail")
        .setValidators([
          Validators.required,
          Validators.pattern(CommonService.EMAIL_REGEXP),
        ]);
      this.tenderForm.get("contactEmail").updateValueAndValidity();
      this.tenderForm.get("city").setValidators([Validators.required]);
      this.tenderForm.get("city").updateValueAndValidity();
      this.tenderForm.get("address").setValidators([Validators.required]);
      this.tenderForm.get("address").updateValueAndValidity();
      this.tenderForm.get("zipCode").setValidators([Validators.required]);
      this.tenderForm.get("zipCode").updateValueAndValidity();
    } else {
      this.tenderForm.get("contactName").clearValidators();
      this.tenderForm.get("contactName").updateValueAndValidity();
      this.tenderForm.get("contactPhone").clearValidators();
      this.tenderForm.get("contactPhone").updateValueAndValidity();
      this.tenderForm.get("contactEmail").clearValidators();
      this.tenderForm
        .get("contactEmail")
        .setValidators([Validators.pattern(CommonService.EMAIL_REGEXP)]);
      this.tenderForm.get("contactEmail").updateValueAndValidity();
      this.tenderForm.get("city").clearValidators();
      this.tenderForm.get("city").updateValueAndValidity();
      this.tenderForm.get("address").clearValidators();
      this.tenderForm.get("address").updateValueAndValidity();
      this.tenderForm.get("zipCode").clearValidators();
      this.tenderForm.get("zipCode").updateValueAndValidity();
    }

    const controls = this.tenderForm.controls;
    this.tenderForm.updateValueAndValidity();
    Object.keys(controls).forEach((controlName) =>
      controls[controlName].updateValueAndValidity()
    );
    Object.keys(controls).forEach((controlName) =>
      controls[controlName].markAsDirty()
    );
    //TODO check if serial number value is empty --> nessuna informazione
  }

  validatePublishData() {
    let valid = true;

    this.needForSubmit = true;

    if (!this.validateSaveData()
      || !this.vaidateMinimumRequirements()
      || !this.validateCluster()
      || !this.validateClusterSectors()) 
   {
      valid = false;
    }

    if (this.tenderForm.get("maximumEstimateDate").invalid) {
      this.maximumEstimateDateAlert = "ng-date-container-alert";
    } else {
      this.maximumEstimateDateAlert = "";
    }

    if (this.qualifications === null || this.qualifications === undefined) {
      this.errorQualifications = true;
      if (valid) {
        const invalidElement: HTMLElement =
          document.getElementById("qualifications");
        this.invalidControlScrollDirective.manualScrollToFirstInvalidElementRef(
          invalidElement
        );
      }
      valid = false;
    }

    if (this.visibility === null || this.visibility === undefined) {
      this.errorVisibility = true;
      if (valid) {
        const invalidElement: HTMLElement =
          document.getElementById("visibility");
        this.invalidControlScrollDirective.manualScrollToFirstInvalidElementRef(
          invalidElement
        );
      }
      valid = false;
    }

    if (this.subcontract === null || this.subcontract === undefined) {
      this.errorSubcontract = true;
      if (valid) {
        const invalidElement: HTMLElement =
          document.getElementById("subcontract");
        this.invalidControlScrollDirective.manualScrollToFirstInvalidElementRef(
          invalidElement
        );
      }
      valid = false;
    }

    if (this.showBestOffer === null || this.showBestOffer === undefined) {
      this.errorShowBestOffer = true;
      if (valid) {
        const invalidElement: HTMLElement =
          document.getElementById("showBestOffer");
        this.invalidControlScrollDirective.manualScrollToFirstInvalidElementRef(
          invalidElement
        );
      }
      valid = false;
    }

    if (!this.requestDataEntryType) {
      this.errorRequestDataEntryType = true;
      if (valid) {
        const invalidElement: HTMLElement = document.getElementById(
          "requestDataEntryTypeSection"
        );
        this.invalidControlScrollDirective.manualScrollToFirstInvalidElementRef(
          invalidElement
        );
      }
      valid = false;
    }

    if (
      this.requestDataEntryType === "METRIC_CALCULATION" &&
      (this.metricCalculationDoc === null ||
        this.metricCalculationDoc === undefined)
    ) {
      this.errorMetricCalculationDoc = true;
      this.metricComputationMsg =
        "Per poter pubblicare la gara è necessario caricare il computo metrico.";
      this.metricComputationMsgClass = "alert";
      valid = false;
    }

    if (
      this.requestDataEntryType !== "METRIC_CALCULATION" &&
      this.requestDetails.length === 0
    ) {
      this.detailListError =
        "Per poter pubblicare la gara è necessario inserire almeno un dettaglio.";
      valid = false;
    }

    this.needForSubmit = false;

    return valid;
  }

  confirmationModalSubmit() {
    if (this.loadedTender.tenderStatus === "DRAFT") {
      this.publishTender();
    } else if (
      (this.loadedTender.tenderStatus === "ONGOING" ||
        this.loadedTender.tenderStatus === "DISCOUNT") &&
      this.draftParticipations.length === 0
    ) {
      this.requireDiscount();
    } else if (
      (this.loadedTender.tenderStatus === "ONGOING" ||
        this.loadedTender.tenderStatus === "DISCOUNT") &&
      this.draftParticipations.length > 0
    ) {
      this.confirmationModalDeal.close();
    } else if (
      this.loadedTender.tenderStatus === "DEAL" &&
      this.isGoingToAcceptTender
    ) {
      this.acceptTender();
    } else if (
      this.loadedTender.tenderStatus === "DEAL" &&
      !this.isGoingToAcceptTender
    ) {
      this.refuseTender();
    }
  }

  applicationsModalSubmit() {
    if (this.applicationsModalAcceptance) {
      this.acceptApplication(this.participationIdSelected);
    } else if (!this.applicationsModalAcceptance) {
      this.refuseApplication(this.participationIdSelected);
    }

    this.participationIdSelected = null;
    this.applicationsModalAcceptance = null;
  }

  acceptApplication(id: number) {
    this.loading = true;
    this.applicationsModal.close();

    this.commonService
      .getParticipationWorkflowService()
      .tenderParticipationParticipationIdAcceptPut(id)
      .subscribe(
        (participation: Participation) => {
          this.loading = false;
          participation.accepted = true;

          this.saveMessage = "Il candidato è stato accettato correttamente.";
          this.showSaveMessage = true;

          var that = this;
          setTimeout(function () {
            that.showSaveMessage = false;
          }, 4000);

          this.commonService
            .getTenderService()
            .tenderTenderIdGet(this.tenderId)
            .subscribe(
              (tender) => {
                console.log("loaded tender");
                console.log(tender);
                this.loadedTender = tender;
                this.loadTenderInForm(tender);
                this.loadParticipations(tender);
                this.loadMinimumRequirements(tender);
                this.loadClusterSectors(tender);
              },
              (error) => {
                console.log(
                  "Impossibile caricare la gara " +
                    this.tenderId +
                    "; error: " +
                    error
                );
              },
              () => {
                this.getBestOffers();
              }
            );
        },
        (error) => {
          if (error.status === 400) {
            this.error = error.error.errors[0].text;
          } else {
            this.error =
              "Si è verificato un errore durante l'accettazione del candidato.";
          }
          this.loading = false;
          console.log(error);
        }
      );
  }

  refuseApplication(id: number) {
    this.loading = true;
    this.applicationsModal.close();

    this.commonService
      .getParticipationWorkflowService()
      .tenderParticipationParticipationIdRefusePut(id)
      .subscribe(
        (participation: Participation) => {
          this.loading = false;
          participation.accepted = false;

          this.saveMessage = "Il candidato è stato accettato correttamente.";
          this.showSaveMessage = true;

          var that = this;
          setTimeout(function () {
            that.showSaveMessage = false;
          }, 4000);

          this.commonService
            .getTenderService()
            .tenderTenderIdGet(this.tenderId)
            .subscribe(
              (tender) => {
                console.log("loaded tender");
                console.log(tender);
                this.loadedTender = tender;
                this.loadTenderInForm(tender);
                this.loadParticipations(tender);
                this.loadMinimumRequirements(tender);
                this.loadClusterSectors(tender);
              },
              (error) => {
                console.log(
                  "Impossibile caricare la gara " +
                    this.tenderId +
                    "; error: " +
                    error
                );
              },
              () => {
                this.getBestOffers();
              }
            );
        },
        (error) => {
          if (error.status === 400) {
            this.error = error.error.errors[0].text;
          } else {
            this.error =
              "Si è verificato un errore durante il rifiuto del candidato.";
          }
          this.loading = false;
          console.log(error);
        }
      );
  }

  tryPublishTender() {
    if (!this.validatePublishData()) {
      this.error = "I campi non sono compilati correttamente.";
      console.log("Invalid tender pubblish data.");
      this.loading = false;
      return;
    } else {
      this.error = "no_error";
      this.openConfirmationModal();
    }
  }

  publishTender() {
    this.loading = true;
    this.confirmationModal.close();

    let tender: Tender = this.getTender();

    tender.cluster = this.loadedTender.cluster;

    tender.minimumRequirements = this.minimumRequirements.map(
      (item) => item.minimumRequirement
    );
    tender.clusterSectors = this.clusterSectors.map(
      (item) => item.clusterSector
    );

    
    this.commonService
      .getWorkflowService()
      .tenderTenderIdPublishPut(tender.tenderId, tender)
      .subscribe(
        (tender: Tender) => {
          this.loadedTender = tender;
          this.loadTenderInForm(tender);
          this.loading = false;

          this.saveMessage = "La gara è stata pubblicata correttamente.";
          this.showSaveMessage = true;

          var that = this;
          setTimeout(function () {
            that.showSaveMessage = false;
          }, 4000);
        },
        (error) => {
          if (error.status === 400) {
            this.error = error.error.errors[0].text;
          } else {
            this.error =
              "Si è verificato un errore durante la pubblicazione della gara.";
          }
          this.loading = false;
          console.log(error);
        }
      );
  }

  setQualification(qualifications: boolean) {
    this.qualifications = qualifications;
    this.tenderForm.patchValue({ qualificationsTrue: qualifications });
    this.tenderForm.patchValue({ qualificationsFalse: !qualifications });
    this.errorQualifications = false;
  }

  setVisibility(visibility: boolean) {
    this.visibility = visibility;
    this.tenderForm.patchValue({ visibilityTrue: visibility });
    this.tenderForm.patchValue({ visibilityFalse: !visibility });
    this.errorVisibility = false;
  }

  setSubcontract(subcontract: boolean) {
    this.subcontract = subcontract;
    this.tenderForm.patchValue({ subcontractTrue: subcontract });
    this.tenderForm.patchValue({ subcontractFalse: !subcontract });
    this.errorSubcontract = false;
  }

  setShowBestOffer(showBestOffer: boolean) {
    this.showBestOffer = showBestOffer;
    this.tenderForm.patchValue({ showBestOfferTrue: showBestOffer });
    this.tenderForm.patchValue({ showBestOfferFalse: !showBestOffer });
    this.errorShowBestOffer = false;
  }

  setRequestDataEntryType(requestDataEntryType: string) {
    this.requestDataEntryType = requestDataEntryType;
    if (requestDataEntryType === "METRIC_CALCULATION") {
      this.tenderForm.patchValue({
        requestDataEntryTypeMetricCalculation: true,
      });
      this.tenderForm.patchValue({ requestDataEntryTypeDetailList: false });
    } else {
      this.tenderForm.patchValue({
        requestDataEntryTypeMetricCalculation: false,
      });
      this.tenderForm.patchValue({ requestDataEntryTypeDetailList: true });
    }
  }

  getDocumentTypeDescription(attachment: Base64Document) {
    return GetTenderAttachmentTypeDersciption(attachment);
  }

  maxAttachmentLimitReached() {
    if (
      this.loadedTender.tenderType === "PRIVATE" &&
      this.attachments.length >= this.privateTenderMaxAttachmentNumber
    ) {
      return true;
    }
    return false;
  }

  uploadImageInputClick() {
    if (this.maxAttachmentLimitReached()) {
      this.toManyAttachmentsWarningModal.open();
    } else {
      this.uploadImageInput.nativeElement.click();
    }
  }

  uploadDrawingInputClick() {
    if (this.maxAttachmentLimitReached()) {
      this.toManyAttachmentsWarningModal.open();
    } else {
      this.uploadDrawingInput.nativeElement.click();
    }
  }

  uploadOtherInputClick() {
    if (this.maxAttachmentLimitReached()) {
      this.toManyAttachmentsWarningModal.open();
    } else {
      this.uploadOtherInput.nativeElement.click();
    }
  }

  uploadAttachment(
    attachmentType: string,
    event: { target: { files: any[] } }
  ) {
    let files = event.target.files;
    let file = files[0];
    if (files && file) {
      const reader = new FileReader();
      let attachment: Base64Document = {};
      attachment.documentType = attachmentType;
      attachment.fileName = file.name;
      attachment.mimeType = file.type;
      attachment.publiclyVisible = false;
      reader.onload = (readerEvt: { target: { result: any } }) => {
        return this.handleReaderLoaded(attachment, readerEvt);
      };
      reader.readAsBinaryString(file);

      if (attachmentType) {
        this.attachments.push(attachment);
      } else {
        //It's metric calculation
        this.metricCalculationDoc = attachment;
        this.metricCalculationModal.close();
        this.errorMetricCalculationDoc = true;
        this.metricComputationMsg = "Computo metrico caricato correttamente.";
        this.metricComputationMsgClass = "info";

        var that = this;
        setTimeout(function () {
          that.errorMetricCalculationDoc = false;
          this.metricComputationMsg =
            "Per poter pubblicare la gara è necessario caricare il computo metrico.";
          this.metricComputationMsgClass = "alert";
        }, 4000);
      }
    }
  }

  handleReaderLoaded(
    attachment: Base64Document,
    readerEvt: { target: { result: any } }
  ) {
    let binaryString = readerEvt.target.result;
    let base64textString = btoa(binaryString);
    attachment.base64Content = base64textString;
  }

  deleteAttachment(attachment: Base64Document) {
    this.attachments = this.attachments.filter((obj) => obj !== attachment);
  }

  openAttachment(attachment: Base64Document, event: any) {
    if (attachment.documentUrl) {
      window.open(attachment.documentUrl);
      if (event !== null && event !== undefined) {
        event.stopPropagation();
      }
    }
  }

  getDownloadButtonStyle(attachment: Base64Document) {
    if (attachment && attachment.documentUrl) {
      return "";
    } else {
      return "-disabled";
    }
  }

  goToTenders() {
    this.router.navigate(["/areariservata"], {
      queryParams: { tabToLoad: "tenders" },
    });
    //window.open('/areariservata?tabToLoad=tenders','_self');
  }

  selectParticipation(selectableParticipation: SelectableParticipation) {
    this.error = "no_error";
    if (selectableParticipation.selectedClass === "") {
      selectableParticipation.selectedClass = "ng-selected-participation";
    } else {
      selectableParticipation.selectedClass = "";
    }
  }

  openConfirmationModal() {
    if (this.loadedTender.tenderStatus === "DRAFT") {
      this.confirmationModalMsg =
        "Si è sicuri di voler pubblicare la gara? Una volta pubblicata, non sarà più possibile modificare la gara e i suoi allegati.";
      this.confirmationModalSubmitMsg = "PUBBLICA";
      this.confirmationModal.open();
    } else if (
      (this.loadedTender.tenderStatus === "ONGOING" ||
        this.loadedTender.tenderStatus === "DISCOUNT") &&
      this.draftParticipations.length === 0
    ) {
      this.confirmationModalMsg =
        "Si è sicuri di voler richiedere uno sconto per questa gara?";
      this.confirmationModalSubmitMsg = "RICHIEDI SCONTO";
      this.confirmationModal.open();
    } else if (
      (this.loadedTender.tenderStatus === "ONGOING" ||
        this.loadedTender.tenderStatus === "DISCOUNT") &&
      this.draftParticipations.length > 0
    ) {
      this.confirmationModalMsg =
        "Non è possibile richiedere uno sconto per questa gara senza aver accettato o rifiutato tutte le candidature.";
      this.confirmationModalSubmitMsg = "HO CAPITO";
      this.confirmationModalDeal.open();
    }
  }

  openApplicationsModal(acceptance: boolean, participationId: number) {
    if (acceptance) {
      this.applicationsModalMsg =
        "Si è sicuri di voler accettare la candidatura? Una volta accettata non sarà più possibile modificare l'azione.";
      this.applicationsModalSubmitMsg = "ACCETTA";
    } else if (!acceptance) {
      this.applicationsModalMsg =
        "Si è sicuri di voler rifiutare la candidatura? Una volta rifiutata non sarà più possibile modificare l'azione.";
      this.applicationsModalSubmitMsg = "RIFIUTA";
    }

    this.participationIdSelected = participationId;
    this.applicationsModalAcceptance = acceptance;

    this.applicationsModal.open();
  }

  requireDiscount() {
    this.loading = true;
    this.confirmationModal.close();

    const selectedParticipationNum = this.publishedParticipations.reduce(
      (acc, item) =>
        acc + (item.selectedClass === "ng-selected-participation" ? 1 : 0),
      0
    );
    if (selectedParticipationNum === 0) {
      this.error =
        "Per poter richiedere uno sconto sulla gara è necessario selezionare almeno un partecipante.";
      console.log("Invalid tender deal data.");
      this.loading = false;
      return;
    } else {
      let selectedParticipations = this.publishedParticipations.filter(
        (item) => item.selectedClass === "ng-selected-participation"
      );
      this.loadedTender.participations = selectedParticipations.map(
        (item) => item.participation
      );
      this.error = "no_error";
    }

    if (this.loadedTender.tenderStatus === "ONGOING") {
      this.commonService
        .getWorkflowService()
        .tenderTenderIdDiscountPut(this.tenderId, this.loadedTender)
        .subscribe(
          (tender: Tender) => {
            this.loading = false;
            this.loadedTender = tender;
            this.loadTenderInForm(tender);
            this.loadParticipations(tender);

            this.saveMessage = "La gara è passata in fase di richiesta sconto.";
            this.showSaveMessage = true;

            var that = this;
            setTimeout(function () {
              that.showSaveMessage = false;
            }, 4000);
          },
          (error) => {
            if (error.status === 400) {
              this.error = error.error.errors[0].text;
            } else {
              this.error =
                "Si è verificato un errore durante il salvataggio della gara.";
            }
            this.loading = false;
            console.log(error);
          }
        );
    } else if (this.loadedTender.tenderStatus === "DISCOUNT") {
      this.commonService
        .getWorkflowService()
        .tenderTenderIdDealPut(this.tenderId, this.loadedTender)
        .subscribe(
          (tender: Tender) => {
            this.loading = false;
            this.loadedTender = tender;
            this.loadTenderInForm(tender);
            this.loadParticipations(tender);

            this.saveMessage = "La gara è passata in fase di accordo.";
            this.showSaveMessage = true;

            var that = this;
            setTimeout(function () {
              that.showSaveMessage = false;
            }, 4000);
          },
          (error) => {
            if (error.status === 400) {
              this.error = error.error.errors[0].text;
            } else {
              this.error =
                "Si è verificato un errore durante il salvataggio della gara.";
            }
            this.loading = false;
            console.log(error);
          }
        );
    } else {
      this.error =
        "Non è possibile richiedere uno sconto in questo stato della gara.";
    }
  }

  confirmRefuseTender() {
    this.confirmationModalMsg = "Si è sicuri di voler rifiutare la gara?";
    this.confirmationModalSubmitMsg = "RIFIUTA";
    this.isGoingToAcceptTender = false;
    this.confirmationModal.open();
  }

  confirmAcceptTender() {
    const selectedParticipationNum = this.publishedParticipations.reduce(
      (acc, item) =>
        acc + (item.selectedClass === "ng-selected-participation" ? 1 : 0),
      0
    );
    if (selectedParticipationNum === 0 || selectedParticipationNum > 1) {
      this.error =
        "Per poter terminare la gara è necessario selezionare un unico partecipante.";
      console.log("Invalid tender accept data.");
      return;
    } else {
      let selectedParticipations = this.publishedParticipations.filter(
        (item) => item.selectedClass === "ng-selected-participation"
      );
      this.loadedTender.participations = selectedParticipations.map(
        (item) => item.participation
      );
      this.error = "no_error";
    }
    this.confirmationModalMsg = "Si è sicuri di voler accettare la gara?";
    this.confirmationModalSubmitMsg = "ACCETTA";
    this.isGoingToAcceptTender = true;
    this.confirmationModal.open();
  }

  acceptTender() {
    this.loading = true;
    this.confirmationModal.close();
    this.commonService
      .getWorkflowService()
      .tenderTenderIdAcceptPut(this.tenderId, this.loadedTender)
      .subscribe(
        (tender: Tender) => {
          this.loading = false;
          this.loadedTender = tender;
          this.loadTenderInForm(tender);
          this.loadParticipations(tender);

          this.saveMessage = "La gara è terminata.";
          this.showSaveMessage = true;

          var that = this;
          setTimeout(function () {
            that.showSaveMessage = false;
          }, 4000);
        },
        (error) => {
          if (error.status === 400) {
            this.error = error.error.errors[0].text;
          } else {
            this.error =
              "Si è verificato un errore durante il salvataggio della gara.";
          }
          this.loading = false;
          console.log(error);
        }
      );
  }

  refuseTender() {
    this.loadedTender.participations = [];
    this.loading = true;
    this.confirmationModal.close();
    this.commonService
      .getWorkflowService()
      .tenderTenderIdRefusePut(this.tenderId, this.loadedTender)
      .subscribe(
        (tender: Tender) => {
          this.loading = false;
          this.loadedTender = tender;
          this.loadTenderInForm(tender);
          this.loadParticipations(tender);

          this.saveMessage = "La gara è stata rifiutata.";
          this.showSaveMessage = true;

          var that = this;
          setTimeout(function () {
            that.showSaveMessage = false;
          }, 4000);
        },
        (error) => {
          if (error.status === 400) {
            this.error = error.error.errors[0].text;
          } else {
            this.error =
              "Si è verificato un errore durante il salvataggio della gara.";
          }
          this.loading = false;
          console.log(error);
        }
      );
  }

  goToQuestionsAndAnswers() {
    this.router.navigate(["/areariservata"], {
      queryParams: {
        tabToLoad: "tenderQuestionsAndAnswers",
        openedFrom: "tender",
        tenderId: this.tenderId,
        tenderTitle: this.tenderForm.get("title").value,
        editable: this.isShareVisible(),
      },
    });
    // window.open('/areariservata?tabToLoad=questionsAndAnswers&openedFrom=tender&tenderId=' + this.tenderId +
    //             '&tenderTitle=' + this.tenderForm.get('title').value,'_self');
  }

  getEstimate(estimate: number) {
    return estimate ? estimate : 0;
  }

  shareTender() {
    if (!this.sharingForm.valid) {
      const controls = this.sharingForm.controls;
      Object.keys(controls).forEach((controlName) =>
        controls[controlName].markAsDirty()
      );
      return;
    }

    this.sharingLoading = true;

    let sharingRequest: SharingRequest = { tenderId: this.tenderId };
    sharingRequest.username = this.sharingForm.get("sharingEmail").value;

    this.commonService
      .getSharingService()
      .sharingInvitePost(sharingRequest)
      .subscribe(
        (any) => {
          this.sharingEmailRequestModal.close();
          this.sharingEmailOkModal.open();
          this.sharingLoading = false;
        },
        (error) => {
          this.sharingError = error.error.errors[0].text;
          this.sharingLoading = false;
          console.log(error);
        }
      );
  }

  isShareVisible() {
    return (
      !this.loadedTender.customer &&
      this.loadedTender.tenderStatus !== "ACCEPTED" &&
      this.loadedTender.tenderStatus !== "REFUSED" &&
      this.loadedTender.tenderStatus !== "ABORTED"
    );
  }

  getRoundedDistance(distance: number) {
    return Math.round(distance * 100) / 100;
  }

  searchDesigners() {
    this.designerError = "no_error";
    this.commonService
      .getDesignerService()
      .designerGet(10000, 0, this.loadedTender.tenderId, this.designerFilter)
      .subscribe(
        (designerList: DesignerList) => {
          if (designerList.designers.length === 0) {
            this.designerError = "Non ci sono progettisti nella tua zona";
          }
          this.designers = designerList.designers;
          this.showDesignerSelect = true;
        },
        (error) => {
          this.designerError = error.error.errors[0].text;
          console.log(error);
        }
      );
  }

  selectDesigner(designer: DesignerCard) {
    this.showDesignerSelect = false;
    this.designerFilter =
      designer.name + " - " + this.getRoundedDistance(designer.distance);
    this.selectedDesigner = designer;
  }

  closeDesignerSelection() {
    this.showDesignerSelect = false;
    this.designerFilter = null;
    this.selectedDesigner = null;
    this.searchDesignerModal.close();
  }

  searchDesigner() {
    if (
      this.loadedTender.city &&
      this.loadedTender.address &&
      this.loadedTender.addressNumber
    ) {
      this.searchDesignerModal.open();
    } else {
      this.searchDesignerKoModal.open();
    }
  }

  inviteDesigner() {
    if (!this.selectedDesigner) {
      this.designerError = "Selezionare un designer";
      return;
    }

    this.designerLoading = true;

    let sharingRequest: SharingRequest = { tenderId: this.tenderId };
    sharingRequest.username = this.selectedDesigner.email;

    this.commonService
      .getSharingService()
      .sharingInvitePost(sharingRequest)
      .subscribe(
        (any) => {
          this.searchDesignerModal.close();
          this.searchDesignerOkModal.open();
          this.designerLoading = false;
        },
        (error) => {
          this.designerError = error.error.errors[0].text;
          this.designerLoading = false;
          console.log(error);
        }
      );
  }

  addRequestDetail() {
    this.detailListError = "no_error";
    let newRequestDetail: RequestDetail = {
      description: null,
      unitOfMeasureCode: null,
      amount: null,
    };
    this.requestDetails.push(newRequestDetail);
  }

  deleteReQuestDetail(requestDetail: RequestDetail) {
    this.requestDetails = this.requestDetails.filter(
      (item) => item !== requestDetail
    );
  }

  upgradeTender() {
    localStorage.setItem("TENDER_TITLE", this.loadedTender.title);
    localStorage.setItem("TENDER_DESCRIPTION", this.loadedTender.description);
    this.router.navigate(["/acquistaupgrade"], {
      queryParams: { tenderId: this.loadedTender.tenderId },
    });
  }

  verifyMetricCalculation() {
    let tender: Tender = this.getTender();
    this.loading = true;
    this.commonService
      .getWorkflowService()
      .tenderTenderIdVerifyMetricCalculationPut(tender.tenderId, tender)
      .subscribe(
        (tender: Tender) => {
          let processedMetricCalculationDoc =
            tender.processedMetricCalculationDoc;
          this.openAttachment(processedMetricCalculationDoc, null);
          this.loading = false;
        },
        (error) => {
          this.metricComputationMsg =
            "Si è verificato un errore. Riprovare più tardi.";
          console.log(error);
          this.loading = false;
        }
      );
  }

  getFeedbackLink(id: number) {
    this.commonService
      .getFeedbackService()
      .feedbackTokenTenderIdPost(id)
      .subscribe(
        (res) => {
          console.log("risposta");
          console.log(res);
        },
        (error) => {
          if (error.status == 200) {
            window.open(error.error.text);
          } else {
            this.router.navigate(["feedback-errore"]);
          }
        }
      );
  }

  checkDate(d) {
    let d1 = new Date(d);
    let d2 = new Date();
    if (d1 > d2) {
      return false;
    } else {
      return true;
    }
  }

  checkFeedbackToken(id) {
    this.commonService
      .getFeedbackService()
      .feedbackTokenTenderIdPost(id)
      .subscribe(
        (res) => {
          console.log(res);
        },
        (error) => {
          console.log(error);
          if (error.status == 200) {
            this.feedbackExists = true;
          } else {
            this.feedbackExists = false;
          }
        }
      );
  }

  addMinimumRequirement() {
    let minimumRequirement: MinimumRequirement = {
      id: null,
      name: null,
      value: null,
    };

    let minimumRequirementItem: MinimumRequirementItem = {
      minimumRequirement,
      errorMessage: null,
    };

    this.minimumRequirements.push(minimumRequirementItem);
    console.log(minimumRequirementItem);
    console.log(this.minimumRequirements);
  }

  setMinimumRequirementName(minimumRequirementItem: MinimumRequirementItem) {
    if (
      this.minimumRequirements.filter(
        (item) =>
          item.minimumRequirement.name ===
          minimumRequirementItem.minimumRequirement.name
      ).length > 1
    ) {
      minimumRequirementItem.errorMessage =
        "Questo requisito minimo esiste già. Aggiungine uno diverso.";
      return;
    }
  }

  removeMinimumRequirement(minimumRequirement: MinimumRequirement) {
    this.minimumRequirements = this.minimumRequirements.filter(
      (item) => item !== minimumRequirement
    );
  }

  loadMinimumRequirements(tender: Tender) {
    this.minimumRequirements = tender.minimumRequirements.map((item) => ({
      minimumRequirement: item,
      errorMessage: null,
    }));
  }

  vaidateMinimumRequirements() {
    let isValid: boolean = true;
    let formValues = this.tenderForm.getRawValue();
    console.log(formValues);

    let tender: Tender = formValues;
    this.minimumRequirements.forEach((element) => {
      if (
        element.minimumRequirement.name === null ||
        element.minimumRequirement.value === null ||
        element.minimumRequirement.name === undefined ||
        element.minimumRequirement.value === undefined ||
        element.minimumRequirement === null ||
        element.minimumRequirement === undefined
      ) {
        element.errorMessage =
          "È obbligatorio inserire il nome della richiesta minima e il suo valore";
        isValid = false;
      } else {
        this.resetMinReqError(element);
        isValid = true;
      }
    });

    return isValid;
  }

  resetMinReqError(minimumRequirement: MinimumRequirementItem) {
    minimumRequirement.errorMessage = null;
    this.resetError();
  }

  toggleMaxApplications() {
    this.showMaxApplications = !this.showMaxApplications;
    this.setMaxApplicationsValidators();
    this.setDefaultMaxApplications();
  }

  setMaxApplication() {
    this.maxApplications = this.tenderForm.get("inputMaxApplications").value;
  }

  setMaxApplicationsValidators() {
    if (!this.showMaxApplications) {
      this.tenderForm.get("inputMaxApplications").setValidators([]);
      this.tenderForm.get("inputMaxApplications").updateValueAndValidity();
    } else {
      this.tenderForm
        .get("inputMaxApplications")
        .setValidators([Validators.required]);
      this.tenderForm.get("inputMaxApplications").updateValueAndValidity();
    }
  }

  setDefaultMaxApplications() {
    if (this.showMaxApplications) {
      if (this.maxApplications === null || this.maxApplications === undefined) {
        this.maxApplications = 50;
        this.tenderForm.patchValue({
          inputMaxApplications: this.maxApplications,
        });
      }
    } else {
      this.maxApplications = null;
      this.tenderForm.patchValue({
        inputMaxApplications: this.maxApplications,
      });
    }
  }

  
  addClusterSector() {
    
    let cs: ClusterSector = {
      clusterSectorId: null,
      clusterSectorCode: null,
      maxParticipants: 4,
    };

    let clusterSectorItem: ClusterSectorItem = {
      clusterSector: cs,
      errorMessage: null
    }
    this.clusterSectors.push(clusterSectorItem);
  }

  removeClusterSector(clusterSector: ClusterSector) {
    this.clusterSectors = this.clusterSectors.filter(
      (item) => item.clusterSector !== clusterSector
    );
  }

  loadClusterSectors(tender: Tender) {
    this.clusterSectors = tender.clusterSectors.map((item) => ({
      clusterSector: item,
      errorMessage: null,
    }));
  }

  validateCluster() {
    let isValid: boolean = true;
    this.clusterErrorMessage = "no_error";
    console.log("CLUSTER PRESENT: " + this.loadedTender.cluster);
    if (this.loadedTender.tenderType === 'CLUSTER' && !this.loadedTender.cluster) {
        this.clusterErrorMessage =
          "È obbligatorio selezionare il cluster";
        isValid = false;
     } 
    
    if (!isValid) {
      let that = this;
      setTimeout(function () {
            let invalidElement: HTMLElement = document.getElementById("cluster-div");
            that.invalidControlScrollDirective.manualScrollToFirstInvalidElementRef(
              invalidElement
            );
          }, 500);
      
    }

    return isValid;
  }

  validateClusterSectors() {
    let isValid: boolean = true;
    let formValues = this.tenderForm.getRawValue();

    let tender: Tender = formValues;

    if (this.loadedTender.cluster && this.clusterSectors.length === 0) {
      this.addClusterSector();
    }

    this.clusterSectors.forEach((element) => {
      if (
        !element.clusterSector.clusterSectorCode ||
        !element.clusterSector.maxParticipants
      ) {
        element.errorMessage =
          "È obbligatorio selezionare il settore e il numero max di partecipanti";
        isValid = false;
      } else {
        this.resetClusterSectorError(element);
        isValid = true;
      }
    });
    
    if (!isValid) {
      let that = this;
      setTimeout(function () {
            let invalidElement: HTMLElement = document.getElementById("cluster-sector");
            that.invalidControlScrollDirective.manualScrollToFirstInvalidElementRef(
              invalidElement
            );
          }, 500);
      
    }

    return isValid;
  }

   resetClusterSectorError(clusterSector: ClusterSectorItem) {
    clusterSector.errorMessage = null;
    this.resetError();
   }
  
   compareById(f1, f2): boolean {
     return f1 && f2 && f1.id === f2.id;
 }
}
